const VideoShowcase = () => {
  return (
    <section className="bg-gradient-to-b from-white to-gray-50 py-12 sm:py-16 md:py-20 lg:py-16">
      <div className="container mx-auto px-5 sm:px-6 lg:px-[15px]">
        {/* Heading */}
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-brand-navy leading-tight">
            Reliable and Trustworthy
          </h2>
          <p className="mt-4 quote-text text-base sm:text-lg md:text-xl max-w-2xl mx-auto">
            Discover why leading companies trust us for their staffing solutions
          </p>
        </div>

        {/* Video Container - Optimized for YouTube Shorts (vertical) */}
        <div className="max-w-md mx-auto">
          <div className="relative bg-black rounded-xl overflow-hidden shadow-2xl" style={{ aspectRatio: '9/16' }}>
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src="https://www.youtube.com/embed/LXLnQBmHO0o?si=nPjxAw9oj2DcOwRK"
              title="Reliable and Trustworthy - IMMACULATE"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoShowcase;

